import * as React from 'react';

export interface IProductLineShimmerProps {
    className?: string;
}

function randomWidth(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

const ProductLineShimmer: React.FC<IProductLineShimmerProps> = (props) => {
    const {
        className
    } = props;

    const producerWidth = React.useMemo(() => randomWidth(28, 132), []);
    const nameWidth = React.useMemo(() => randomWidth(83.37, 258), []);

    return (
        <tr>
            <td className='no-side-padding' style={{ width: 48.54 }} />
            <td className='no-padding'>
                <div className={`${className}__product__shimmer-image`} />
            </td>
            <td>
                <div className={`${className}__product__shimmer-line`} style={{ width: producerWidth, height: 11.11, marginBottom: 4 }} />
                <div className={`${className}__product__shimmer-line`} style={{ width: nameWidth, height: 14.77 }} />
            </td>
            <td>
                <div className={`${className}__product__shimmer-line`} style={{ width: 50, height: 14.55 }} />
            </td>
            <td className='quantity no-side-padding right-align'>
                <div className={`${className}__product__shimmer-line`} style={{ width: 285.33, height: 28.21 }} />
            </td>
            <td className='price-summary nowrap no-side-padding'>
                <div className={`${className}__product__shimmer-line`} style={{ width: 70, height: 16.37 }} />
            </td>
            <td className='no-side-padding right-align' style={{ width: 88.19 }} />
            <td className='no-side-padding' style={{ width: 72.83 }} />
        </tr>
    );
};

export default ProductLineShimmer;
